import { signOut } from 'aws-amplify/auth';

/**
 * Amplify認証キャッシュを完全にクリアする
 * CloudFormationスタック削除後の署名キー不整合問題を解決
 */
export const clearAuthCache = async () => {
  try {
    console.log('🔄 認証キャッシュクリア開始...');
    
    // 1. Amplifyからサインアウト
    await signOut({ global: true });
    console.log('✅ Amplifyサインアウト完了');
    
    // 2. LocalStorageの認証関連データをクリア
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (
        key.includes('amplify') ||
        key.includes('cognito') ||
        key.includes('aws') ||
        key.includes('CognitoIdentityServiceProvider') ||
        key.includes('auth')
      )) {
        keysToRemove.push(key);
      }
    }
    
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
      console.log(`🗑️ LocalStorage削除: ${key}`);
    });
    
    // 3. SessionStorageもクリア
    const sessionKeysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && (
        key.includes('amplify') ||
        key.includes('cognito') ||
        key.includes('aws') ||
        key.includes('CognitoIdentityServiceProvider') ||
        key.includes('auth')
      )) {
        sessionKeysToRemove.push(key);
      }
    }
    
    sessionKeysToRemove.forEach(key => {
      sessionStorage.removeItem(key);
      console.log(`🗑️ SessionStorage削除: ${key}`);
    });
    
    console.log('✅ 認証キャッシュクリア完了');
    
    // 4. ページリロード
    console.log('🔄 ページリロード...');
    window.location.reload();
    
  } catch (error) {
    console.error('❌ 認証キャッシュクリアエラー:', error);
    // エラーが発生してもページリロードは実行
    window.location.reload();
  }
};

/**
 * 認証エラー時の自動復旧
 */
export const handleAuthError = async (error) => {
  console.error('🚨 認証エラー検出:', error);
  
  // JWTトークン関連エラーの場合
  if (error.message && (
    error.message.includes('token') ||
    error.message.includes('expired') ||
    error.message.includes('unauthorized') ||
    error.message.includes('invalid') ||
    error.message.includes('signature')
  )) {
    console.log('🔧 JWTトークン問題を検出 - 認証キャッシュクリア実行');
    await clearAuthCache();
  }
}; 